if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        // this.cart =
        //   document.querySelector('cart-notification') ||
        //   document.querySelector('cart-drawer');

        this.cart = document.querySelector('mini-cart');

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (
          this.submitButton.getAttribute('aria-disabled') === 'true'
        ) {
          return;
        }

        if (!this.blockSubmitIfRequiredFieldsEmpty(evt)) {
          return;
        }

        /*
         * Registrer tidspunktet hvor kunden klikker.
         *
         * Quick View bliver stående i minimum 500 ms,
         * så loading-animationen på knappen når at blive vist.
         */
        const submitStartedAt = performance.now();

        this.handleErrorMessage();

        this.submitButton.setAttribute(
          'aria-disabled',
          true
        );

        this.submitButton.classList.add('loading');

        // this.querySelector('.loading__spinner')
        //   .classList.remove('hidden');


        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] =
          'XMLHttpRequest';

        delete config.headers['Content-Type'];


        const formData = new FormData(this.form);


        if (this.cart) {
          formData.append(
            'sections',
            this.cart
              .getSectionsToRender()
              .map((section) => section.id)
          );

          formData.append(
            'sections_url',
            window.location.pathname
          );

          this.cart.setActiveElement(
            document.activeElement
          );
        }


        config.body = formData;


        fetch(
          `${theme.routes.cart_add_url}`,
          config
        )

          .then((response) => response.json())

          .then((response) => {

            /*
             * =================================================
             * CART ERROR
             * =================================================
             */

            if (response.status) {

              publish(
                PUB_SUB_EVENTS.cartError,
                {
                  source: 'product-form',

                  productVariantId:
                    formData.get('id'),

                  errors:
                    response.errors ||
                    response.description,

                  message:
                    response.message,
                }
              );


              this.handleErrorMessage(
                response.description
              );


              const soldOutMessage =
                this.submitButton.querySelector(
                  '.sold-out-message'
                );


              if (!soldOutMessage) {
                return;
              }


              this.submitButton.setAttribute(
                'aria-disabled',
                true
              );


              this.submitButtonText.classList.add(
                'hidden'
              );


              soldOutMessage.classList.remove(
                'hidden'
              );


              this.error = true;

              return;
            }


            /*
             * Ingen mini-cart tilgængelig:
             * gå til almindelig cart page.
             */

            if (!this.cart) {

              window.location =
                theme.routes.cart_url;

              return;
            }


            /*
             * =================================================
             * CART UPDATE EVENT
             * =================================================
             */

            if (!this.error) {

              publish(
                PUB_SUB_EVENTS.cartUpdate,
                {
                  source: 'product-form',

                  productVariantId:
                    formData.get('id'),

                  cart: response,
                }
              );
            }


            this.error = false;


            /*
             * Find ud af om produktet blev tilføjet fra:
             *
             * - Quick Add Modal
             * - Quick View Drawer
             * - Almindelig produktside
             */

            const quickAddModal =
              this.closest(
                'quick-add-modal'
              );


            const quickViewDrawer =
              this.closest(
                'quick-view-drawer'
              );


            /*
             * =================================================
             * QUICK ADD MODAL
             * =================================================
             */

            if (quickAddModal) {

              document.body.addEventListener(
                'modalClosed',

                () => {

                  this.cart.renderContents(
                    response
                  );

                },

                {
                  once: true
                }
              );


              quickAddModal.hide(true);


            /*
             * =================================================
             * QUICK VIEW
             * =================================================
             */

            } else if (quickViewDrawer) {


              /*
               * FLOW:
               *
               * 1. Kunden klikker "Tilføj til kurv"
               *
               * 2. Knappen går straks i loading-state
               *
               * 3. Quick View forbliver synlig i minimum
               *    500 ms fra selve klikket
               *
               * 4. Quick View lukkes
               *
               * 5. Vi venter på QuickViewDrawer-eventet:
               *
               *      quickview:close
               *
               * 6. Først derefter åbnes cart drawer
               *
               *
               * Hvis Shopify allerede bruger mere end
               * 500 ms på requestet, tilføjes der IKKE
               * yderligere ventetid.
               */


              return new Promise((resolve) => {


                /*
                 * Minimum tid hvor kunden skal kunne
                 * se loading-feedback på knappen.
                 */

                const minimumFeedbackTime = 500;


                /*
                 * Hvor lang tid er der allerede gået
                 * siden kunden klikkede?
                 */

                const elapsedTime =
                  performance.now() -
                  submitStartedAt;


                /*
                 * Vent kun den resterende tid.
                 *
                 * Eksempel:
                 *
                 * Request tager 300 ms
                 * → vent yderligere 200 ms.
                 *
                 * Request tager 700 ms
                 * → vent 0 ms.
                 */

                const remainingTime =
                  Math.max(
                    0,
                    minimumFeedbackTime -
                    elapsedTime
                  );


                /*
                 * Åbn cart drawer EFTER
                 * Quick View er lukket.
                 */

                const openCart = () => {

                  requestAnimationFrame(
                    () => {

                      this.cart.renderContents(
                        response
                      );

                      resolve();

                    }
                  );

                };


                /*
                 * QuickViewDrawer udsender
                 * dette event når drawerens
                 * close-flow er færdigt.
                 */

                document.addEventListener(
                  'quickview:close',

                  openCart,

                  {
                    once: true
                  }
                );


                /*
                 * Luk Quick View.
                 */

                const closeQuickView = () => {


                  const closeButton =
                    quickViewDrawer.querySelector(
                      'drawer-close-button'
                    );


                  const details =
                    quickViewDrawer.querySelector(
                      'details[open]'
                    );


                  /*
                   * Foretrukket metode:
                   * brug drawerens rigtige close-button.
                   */

                  if (closeButton) {

                    closeButton.click();


                  /*
                   * Fallback:
                   * luk via details/summary.
                   */

                  } else if (details) {

                    const summary =
                      details.querySelector(
                        'summary'
                      );


                    if (summary) {

                      summary.click();

                    } else {

                      openCart();

                    }


                  /*
                   * Sidste fallback:
                   * hvis drawer-strukturen ikke findes,
                   * åbn kurven direkte.
                   */

                  } else {

                    openCart();

                  }

                };


                /*
                 * Vent kun hvis vi endnu ikke har
                 * nået minimum 500 ms.
                 */

                if (remainingTime > 0) {

                  setTimeout(
                    closeQuickView,
                    remainingTime
                  );

                } else {

                  closeQuickView();

                }

              });


            /*
             * =================================================
             * NORMAL PRODUCT PAGE
             * =================================================
             */

            } else {

              this.cart.renderContents(
                response
              );

            }

          })


          /*
           * ===================================================
           * FETCH ERROR
           * ===================================================
           */

          .catch((e) => {

            console.error(e);

          })


          /*
           * ===================================================
           * CLEANUP
           * ===================================================
           */

          .finally(() => {

            this.submitButton.classList.remove(
              'loading'
            );


            if (
              this.cart &&
              this.cart.classList.contains(
                'is-empty'
              )
            ) {

              this.cart.classList.remove(
                'is-empty'
              );

            }


            if (!this.error) {

              this.submitButton.removeAttribute(
                'aria-disabled'
              );

            }


            // this.querySelector('.loading__spinner')
            //   .classList.add('hidden');

          });
      }


      /*
       * =====================================================
       * REQUIRED LINE ITEM PROPERTIES
       * =====================================================
       */

      blockSubmitIfRequiredFieldsEmpty(event) {

        if (
          !(this.form instanceof HTMLFormElement)
        ) {

          throw new Error(
            'Expected a form element.'
          );

        }


        const formId =
          this.form.getAttribute('id');


        const requiredFields =
          document.querySelectorAll(
            '[required]'
          );


        let allFilled = true;


        for (
          const field of requiredFields
        ) {


          const belongsToForm =

            field.getAttribute('form') ===
              formId ||

            field.closest('form')?.id ===
              formId;


          if (!belongsToForm) {
            continue;
          }


          let isValid = true;


          switch (field.type) {


            case 'checkbox':

            case 'radio': {

              const group =
                document.querySelectorAll(
                  `input[name="${field.name}"][type="${field.type}"]`
                );


              const isChecked =
                Array
                  .from(group)
                  .some(
                    (input) =>
                      input.checked
                  );


              isValid =
                isChecked;


              break;
            }


            case 'select-one':

              isValid =
                field.value !== '';

              break;


            case 'textarea':

            case 'text':

            case 'email':

            case 'number':

            case 'url':

            default:

              isValid =
                field.value.trim() !== '';

              break;

          }


          if (!isValid) {

            allFilled = false;

            field.classList.add(
              'invalid'
            );

          } else {

            field.classList.remove(
              'invalid'
            );

          }

        }


        if (!allFilled) {

          event.preventDefault();


          this.handleErrorMessage(
            theme
              .accessibilityStrings
              .fillInAllLineItemPropertyRequiredFields
          );


          return false;

        }


        return true;
      }


      /*
       * =====================================================
       * ERROR MESSAGE
       * =====================================================
       */

      handleErrorMessage(
        errorMessage = false
      ) {

        if (this.hideErrors) {
          return;
        }


        this.errorMessageWrapper =

          this.errorMessageWrapper ||

          this.querySelector(
            '.product-form__error-message-wrapper'
          );


        if (!this.errorMessageWrapper) {
          return;
        }


        this.errorMessage =

          this.errorMessage ||

          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );


        this.errorMessageWrapper
          .toggleAttribute(
            'hidden',
            !errorMessage
          );


        if (errorMessage) {

          this.errorMessage.textContent =
            errorMessage;

        }
      }


      /*
       * =====================================================
       * SUBMIT BUTTON
       * =====================================================
       */

      toggleSubmitButton(
        disable = true,
        text
      ) {

        if (disable) {

          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );


          if (text) {

            this.submitButtonText.textContent =
              text;

          }

        } else {

          this.submitButton.removeAttribute(
            'disabled'
          );


          this.submitButtonText.textContent =
            theme.variantStrings.addToCart;

        }
      }


      /*
       * =====================================================
       * VARIANT ID
       * =====================================================
       */

      get variantIdInput() {

        return this.form.querySelector(
          '[name=id]'
        );

      }
    }
  );
}